import * as actionType from "./action";

export function usersReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_USERS_SUCCESS:
      return { ...state, response };
    case actionType.GET_USERS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function userReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_USER_SUCCESS:
      return { ...state, response };
    case actionType.GET_USER_ERROR:
      return { ...state, response };
    case actionType.ADD_USER_SUCCESS:
      return state;
    case actionType.ADD_USER_ERROR:
      return { ...state, response };
    case actionType.MODIFY_USER_SUCCESS:
      return state;
    case actionType.MODIFY_USER_ERROR:
      return { ...state, response };
    case actionType.DELETE_USER_SUCCESS:
      return state;
    case actionType.DELETE_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function currentUserReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_CURRENT_USER_SUCCESS:
      return { ...state, response };
    case actionType.GET_CURRENT_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function currentUserChangePasswordReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.CHANGE_PASSWORD_CURRENT_USER_SUCCESS:
      return { ...state, response };
    case actionType.CHANGE_PASSWORD_CURRENT_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
